<script lang="ts">
  import type { WithElementRef } from 'bits-ui';
  import type { HTMLAttributes } from 'svelte/elements';
  import { cn } from '$lib/utils';

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithElementRef<HTMLAttributes<HTMLTableCellElement>> = $props();
</script>

<td
  bind:this={ref}
  class={cn('px-3 py-3 align-middle [&:has([role=checkbox])]:pr-0', className)}
  {...restProps}
>
  {@render children?.()}
</td>
